import {announce} from '@github-ui/aria-live'
import {useMarkReadyForReviewMutation} from '@github-ui/mergebox/use-mark-ready-for-review-mutation'
import {GitPullRequestIcon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'
import {FailureDialog} from './FailureDialog'
import {useInvalidatePrState} from '../data/use-invalidate-pr-state'
import {PullRequestState} from '../../../types'

export function MarkReadyForReviewAction() {
  const invalidatePrState = useInvalidatePrState()

  const markReadyForReviewMutation = useMarkReadyForReviewMutation({
    onSuccess: () => {
      announce('Pull request marked as ready for review')
      invalidatePrState(PullRequestState.Open)
    },
  })

  return (
    <>
      <ActionList.Item
        loading={markReadyForReviewMutation.isPending}
        onSelect={() => markReadyForReviewMutation.mutate()}
      >
        <ActionList.LeadingVisual>
          <GitPullRequestIcon />
        </ActionList.LeadingVisual>
        Mark ready for review
      </ActionList.Item>

      {markReadyForReviewMutation.isError && (
        <FailureDialog
          title="Failed to mark ready for review"
          message="An error occurred while marking this pull request as ready for review. Please try again."
          details={markReadyForReviewMutation.error.message}
          onRetry={() => markReadyForReviewMutation.mutate()}
          onDismiss={() => markReadyForReviewMutation.reset()}
        />
      )}
    </>
  )
}
